import { IStrongBoxComplianceItem } from '@nkr/models/index';
import { Alert, Button } from 'react-bootstrap';
import useStrongBoxAddrApproval from '@nkr/store/strong-box/hooks/use-strong-box-addr-approval';

interface IProps {
    item: IStrongBoxComplianceItem
    onItemResolved: (item: IStrongBoxComplianceItem) => void
}

export default function AddressConfirmationButton({ item, onItemResolved }: IProps) {
    const { error, loading, approve } = useStrongBoxAddrApproval(() => {
        onItemResolved(item);
    });

    if (error) {
        return (<Alert bsStyle='danger'>{error}</Alert>);
    }

    return (
        <Button bsStyle='primary' disabled={loading} onClick={() => approve(item.strongBoxCenterId)}>
            Yes! This is the correct address. {loading && <>(confirming)</>}
        </Button>
    );
}